import { ANALYSIS, BUNDLE, CURRENCY } from "@utils/constant";
import { DISCOUNT_TYPE } from "@utils/enum";

const preparePayload = values => {
  const {
    service_type,
    analysis_type,
    child,
    add_on_products,
    ...otherProperties
  } = values;

  const payload = {
    ...otherProperties,
    service_type: service_type,
    add_on_products: add_on_products?.map(code => code),
  };

  if (service_type === BUNDLE) {
    payload.child = child?.map(code => code);
  } else if (service_type === ANALYSIS) {
    payload.analysis_type = analysis_type;
  } else {
    payload.analysis_type = "manual";
  }

  return payload;
};

export const formatDiscountValue = (value, type) => {
  const symbol = type === DISCOUNT_TYPE.PERCENTAGE ? "%" : CURRENCY;

  return `${value} ${symbol}`;
};

export { preparePayload };
